import styles from './styles.module.scss';
import React from 'react';

const FiltroWrapper = ({ children }) => {
    return (
        <div className={ `report-filter-container ${styles.FiltroWrapper}` }>
            { children }
        </div>
    )
}

export default FiltroWrapper;